// app/javascript/controllers/currency_controller.js
import { Controller } from "stimulus"

export default class extends Controller {
    connect() {
        // Leemos el valor inicial que viene de la sesión Rails
        const initialCurrency = this.element.dataset.currentCurrency || "USD"
        console.log(`Moneda inicial detectada: ${initialCurrency}`)

        // Forzamos el estado interno
        this.currentCurrency = initialCurrency

        // Actualizamos la vista
        this.updateButtonAppearance()
    }

    toggleCurrency(event) {
        event.preventDefault()

        // Invertimos el valor lógico
        const newCurrency = this.currentCurrency === "USD" ? "CUP" : "USD"
        const url = `/admin/hotel/update_currency?currency=${newCurrency}`

        // 1. Actualizamos UI inmediatamente (para que se sienta rápido)
        this.currentCurrency = newCurrency
        this.updateButtonAppearance()

        // 2. Enviamos a servidor
        fetch(url, {
            method: "POST",
            headers: {
                "X-CSRF-Token": document.querySelector("[name='csrf-token']").content,
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            credentials: "same-origin"
        })
            .then(response => response.json())
            .then(data => {
                if (!data.success) {
                    // Si falla el servidor, revertimos visualmente
                    this.currentCurrency = newCurrency === "USD" ? "CUP" : "USD"
                    this.updateButtonAppearance()
                    alert("Hubo un error al cambiar la moneda")
                } else {
                    // Notificamos al resto de la app
                    window.dispatchEvent(new CustomEvent("currencyChanged", {
                        detail: { currency: newCurrency }
                    }))
                }
            })
            .catch(error => {
                console.error("Error:", error)
                // Revertir en caso de error de red
                this.currentCurrency = newCurrency === "USD" ? "CUP" : "USD"
                this.updateButtonAppearance()
            })
    }

    updateButtonAppearance() {
        // Lógica estricta para asegurar coherencia visual:
        // Si el valor es USD -> clase usd-mode (Slider a la izquierda)
        // Si el valor es CUP -> clase cup-mode (Slider a la derecha)

        if (this.currentCurrency === "USD") {
            this.element.classList.remove("cup-mode")
            this.element.classList.add("usd-mode")
        } else {
            this.element.classList.remove("usd-mode")
            this.element.classList.add("cup-mode")
        }
    }
}